import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { workflowSteps } from '../data/content';
import { CTAButton } from './CTAButton';
export function Workflow() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-276" data-mp="1p737x7lhz8sm">
      <div className="mx-auto max-w-3xl" data-id="element-277" data-mp="1p50ai2i0mddv">
        <h2 className="text-center font-display text-2xl font-700 uppercase leading-tight text-slate-300 sm:text-3xl" data-id="element-278" data-mp="1tybmsj5ljmd6">
          This isn’t just another dental guide…
        </h2>
        <p className="mt-2 text-center font-display text-3xl font-700 uppercase leading-tight text-gold-400 sm:text-4xl" data-id="element-279" data-mp="22yhxjx9wu88n">
          It’s a clinical decision system you can use immediately
        </p>

        <p className="mx-auto mt-5 max-w-2xl text-center text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-280" data-mp="2cwe3manzqczw">
          Instead of giving you another textbook-style resource filled with information, DVO Master
          Protocol™ organizes the process into a simple clinical workflow:
        </p>

        <ol className="mx-auto mt-9 max-w-sm" data-id="element-281" data-mp="1vopxy4iwnbw0">
          {workflowSteps.map((step, index) => <li key={step} data-id="element-282" data-mp="1qy9i6drm3e6h" data-mpi={index}>
              <div className="flex items-center gap-4 rounded-xl border border-gold-500/25 bg-navy-900 px-4 py-3.5" data-id="element-283" data-mp="1qxzw319otr62">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold-500 font-display text-base font-700 text-navy-950" data-id="element-284" data-mp="1lzy7y1xen1nq">
                  {index + 1}
                </span>
                <span className="font-display text-xl font-700 uppercase tracking-wide text-white" data-id="element-285" data-mp="2enc2xuhjln57">
                  {step}
                </span>
              </div>
              {index < workflowSteps.length - 1 ? <div className="flex justify-center py-1.5" data-id="element-286" data-mp="24riqsc7qjvny">
                  <ArrowDownIcon className="h-5 w-5 text-gold-500/70" aria-hidden="true" data-id="element-287" data-mp="20nay63y5pvkg" />
                </div> : null}
            </li>)}
        </ol>

        <p className="mt-8 text-center text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-288" data-mp="p8e60l6oeq8v">
          Everything is organized so you can quickly find the tool you need when you’re planning a
          case.
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-289" data-mp="vnuwgfcdj5bv">
          <CTAButton label="Get instant access to the complete system" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-290" data-mp="grx4zadeap5z" />
        </div>
      </div>
    </section>;
}